import {
  type CertificateProgram,
  type CertificateProgramEngagement,
  type Image as ApiImage,
} from '@mc/api'
import Experiment from '@mc/experiments-react'
import { useTranslation } from '@mc/i18n'
import { SUBSCRIPTION_SIGNUP_HREF } from 'pages/certificates/annualpass/data/subscriptionData'
import { PromoModal } from 'pages/certificates/components/PromoModal/PromoModal'
import type {
  PromoVariables,
  ResolvedSubscriptionPromoVariables,
} from 'pages/certificates/promo'
import { TrackingAttributes } from 'pages/certificates/tracking'
import { MCCERTS_2972_SUBS_ONLY_CLP_FLAG } from './constants'
import { MCCERTS_2972_SUBS_ONLY_CLP_I18N_NAMESPACE } from './i18n'
import { useSubsOnlyClpExpBucket } from './utils/useIsSubsOnlyClpExpActive'

export type CMPromoModalSubsOnlyExpProps = {
  program: CertificateProgram
  engagement?: CertificateProgramEngagement
  isPaintedDoor?: boolean
  promoVariables?: PromoVariables | null
  subscriptionPromoVariables?: ResolvedSubscriptionPromoVariables | null
  certThumbnail?: ApiImage
  releaseLabel?: string
  isSubscribed?: boolean
}

const CertPromoModal = ({
  promoVariables,
  certThumbnail,
  releaseLabel,
}: CMPromoModalSubsOnlyExpProps) =>
  promoVariables?.modal ? (
    <PromoModal
      promo={promoVariables.promo}
      modal={promoVariables.modal}
      certThumbnail={certThumbnail}
      releaseLabel={releaseLabel}
    />
  ) : null

const SubscriptionPromoModal = ({
  subscriptionPromoVariables,
  isSubscribed,
}: CMPromoModalSubsOnlyExpProps) => {
  const { t: tExp } = useTranslation(MCCERTS_2972_SUBS_ONLY_CLP_I18N_NAMESPACE)
  if (!subscriptionPromoVariables?.modal || isSubscribed) return null

  return (
    <PromoModal
      promo={subscriptionPromoVariables.promo}
      modal={subscriptionPromoVariables.modal}
      checkoutHref={SUBSCRIPTION_SIGNUP_HREF}
      ctaText={tExp('promoModal.ctaText')}
      ctaAction='Get All Courses'
    />
  )
}

export const CMPromoModalSubsOnlyExp = (
  props: CMPromoModalSubsOnlyExpProps,
) => {
  const bucket = useSubsOnlyClpExpBucket(props)
  if (!bucket) {
    return <CertPromoModal {...props} />
  }

  return (
    <TrackingAttributes variant={bucket}>
      {/* track={false}: the page-level TrackExperimentViewed owns the exposure */}
      <Experiment<CMPromoModalSubsOnlyExpProps>
        {...props}
        name={MCCERTS_2972_SUBS_ONLY_CLP_FLAG}
        track={false}
        default={CertPromoModal}
        variant_1={SubscriptionPromoModal}
        variant_2={SubscriptionPromoModal}
        variant_3={SubscriptionPromoModal}
      />
    </TrackingAttributes>
  )
}
